"use client";
import React from "react";

import { BookingStepsSection } from "./_components/BookingStepsSection/BookingStepsSection";
import { CtaBanner } from "./_components/CtaBanner/CtaBanner";
import { HeroSection } from "./_components/HeroSection/HeroSection";
import { StatsBarSection } from "./_components/StatsBarSection/StatsBarSection";
import { ToolsSection } from "./_components/ToolsSection/ToolsSection";
import { TrustSection } from "./_components/TrustSection/TrustSection";

export default function Page() {
  return (
    <>
      <HeroSection />
      <StatsBarSection />
      <TrustSection />
      <ToolsSection />
      <BookingStepsSection />
      <CtaBanner />
    </>
  );
}
